import { transferRegistrationService } from 'src/modules/transferRegistration/services';
import { modalStore } from 'src/modules/transferRegistration/stores';
import { ModalStoreType } from 'src/modules/transferRegistration/types';

export const onConfirm = () => {
  const { recipientEmail, racerId } = modalStore.value as ModalStoreType;

  transferRegistrationService.saveTransferRegistration(racerId, recipientEmail);
};
